import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-40 flex" }
const _hoisted_2 = { class: "absolute right-0 top-0 -mr-12 pt-2" }
const _hoisted_3 = { class: "template-sidebar-desktop contents" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["TransitionRoot"], {
      as: "template",
      show: $setup.sidebarOpen
    }, {
      default: _withCtx(() => [
        _createVNode($setup["Dialog"], {
          as: "div",
          class: "template-sidebar-dialog relative z-40 md:hidden",
          onClose: $setup.handleDialogCLose
        }, {
          default: _withCtx(() => [
            _createVNode($setup["TransitionChild"], {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "fixed inset-0 bg-gray-600 bg-opacity-75" }, null, -1 /* CACHED */)
              ])),
              _: 1 /* STABLE */,
              __: [0]
            }),
            _createElementVNode("div", _hoisted_1, [
              _createVNode($setup["TransitionChild"], {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["DialogPanel"], { class: "bg-primary relative flex w-full max-w-xs flex-1 flex-col" }, {
                    default: _withCtx(() => [
                      _createVNode($setup["TransitionChild"], {
                        as: "template",
                        enter: "ease-in-out duration-300",
                        "enter-from": "opacity-0",
                        "enter-to": "opacity-100",
                        leave: "ease-in-out duration-300",
                        "leave-from": "opacity-100",
                        "leave-to": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                              onClick: $setup.closeSidebar
                            }, [
                              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1 /* CACHED */)),
                              _createVNode($setup["XIcon"], {
                                class: "h-6 w-6 text-white",
                                "aria-hidden": "true"
                              })
                            ])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3 /* FORWARDED */
                  })
                ]),
                _: 3 /* FORWARDED */
              }),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-14 flex-shrink-0" }, [
                _createCommentVNode(" Force sidebar to shrink to fit close icon ")
              ], -1 /* CACHED */))
            ])
          ]),
          _: 3 /* FORWARDED */
        })
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["show"]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64 /* STABLE_FRAGMENT */))
}